// 原 CSS Modules 的类名映射，去掉构建哈希以便阅读。
export default {
  art: "DropCap__art",
  drop: "DropCap__drop",
  glyph: "DropCap__glyph",
  glyphType: "DropCap__glyphType",
  sr: "DropCap__sr",
};
